// Hobbies and Interests icons
import GolfIcon from "./hobbies/golf.svg";
import YogaIcon from "./hobbies/yoga.svg";
import HikingIcon from "./hobbies/hiking.svg";
import SewingIcon from "./hobbies/sewing.svg";
import GamingIcon from "./hobbies/gaming.svg";
import TennisIcon from "./hobbies/tennis.svg";
import BakingIcon from "./hobbies/baking.svg";
import WritingIcon from "./hobbies/writing.svg";
import PilatesIcon from "./hobbies/pilates.svg";
import PotteryIcon from "./hobbies/pottery.svg";
import KaraokeIcon from "./hobbies/karaoke.svg";
import CampingIcon from "./hobbies/camping.svg";
import EsportsIcon from "./hobbies/esports.svg";
import SingingIcon from "./hobbies/singing.svg";
import CyclingIcon from "./hobbies/cycling.svg";
import SailingIcon from "./hobbies/sailing.svg";
import CookingIcon from "./hobbies/cooking.svg";
import DrawingIcon from "./hobbies/drawing.svg";
import SpaDaysIcon from "./hobbies/spa-days.svg";
import ClimbingIcon from "./hobbies/climbing.svg";
import SwimmingIcon from "./hobbies/swimming.svg";
import RoboticsIcon from "./hobbies/robotics.svg";
import PaintingIcon from "./hobbies/painting.svg";
import ZipliningIcon from "./hobbies/ziplining.svg";
import GardeningIcon from "./hobbies/gardening.svg";
import SkydivingIcon from "./hobbies/skydiving.svg";
import DesigningIcon from "./hobbies/designing.svg";
import SculptureIcon from "./hobbies/sculpture.svg";
import BadmintonIcon from "./hobbies/badminton.svg";
import RoadTripsIcon from "./hobbies/road-trips.svg";
import MeditationIcon from "./hobbies/meditation.svg";
import BasketballIcon from "./hobbies/basketball.svg";
import StargazingIcon from "./hobbies/stargazing.svg";
import JournalingIcon from "./hobbies/journaling.svg";
import BoardGamesIcon from "./hobbies/board-games.svg";
import CalligraphyIcon from "./hobbies/calligraphy.svg";
import ProgrammingIcon from "./hobbies/programming.svg";
import ParaglidingIcon from "./hobbies/paragliding.svg";
import PhotographyIcon from "./hobbies/photography.svg";
import BackpackingIcon from "./hobbies/backpacking.svg";
import ActingDramaIcon from "./hobbies/acting-drama.svg";
import DiyCraftingIcon from "./hobbies/diy-crafting.svg";
import KiteSurfingIcon from "./hobbies/kite-surfing.svg";
import EscapeRoomsIcon from "./hobbies/escape-rooms.svg";
import MartialArtsIcon from "./hobbies/martial-arts.svg";
import SpeedDatingIcon from "./hobbies/speed-dating.svg";
import CharityWorkIcon from "./hobbies/charity-work.svg";
import WineTastingIcon from "./hobbies/wine-tasting.svg";
import HorseRidingIcon from "./hobbies/horse-riding.svg";
import AromatherapyIcon from "./hobbies/aromatherapy.svg";
import VolunteeringIcon from "./hobbies/volunteering.svg";
import BirdWatchingIcon from "./hobbies/bird-watching.svg";
import ScrapBookingIcon from "./hobbies/scrap-booking.svg";
import FoodBloggingIcon from "./hobbies/food-blogging.svg";
import FoodAndDrinkIcon from "./hobbies/food-and-drink.svg";
import BungeeJumpingIcon from "./hobbies/bungee-jumping.svg";
import CoffeeCultureIcon from "./hobbies/coffee-culture.svg";
import CulinaryToursIcon from "./hobbies/culinary-tours.svg";
import LuxuryCruisesIcon from "./hobbies/luxury-cruises.svg";
import WatchingMoviesIcon from "./hobbies/watching-movies.svg";
import SoccerFootballIcon from "./hobbies/soccer-football.svg";
import RunningJoggingIcon from "./hobbies/running-jogging.svg";
import ArtsAndCultureIcon from "./hobbies/arts-and-culture.svg";
import JewelleryMakingIcon from "./hobbies/jewellery-making.svg";
import CreativeHobbiesIcon from "./hobbies/creative-hobbies.svg";
import GymWeightliftingIcon from "./hobbies/gym-weightlifting.svg";
import PodcastListeningIcon from "./hobbies/podcast-listening.svg";
import TriviaQuizNightsIcon from "./hobbies/trivia-quiz-nights.svg";
import NatureAndAnimalsIcon from "./hobbies/nature-and-animals.svg";
import NetworkingEventsIcon from "./hobbies/networking-events.svg";
import SportsAndFitnessIcon from "./hobbies/sports-and-fitness.svg";
import AttendingConcertsIcon from "./hobbies/attending-concerts.svg";
import TechGadgetReviewsIcon from "./hobbies/tech-gadget-reviews.svg";
import DogWalkingPetCareIcon from "./hobbies/dog-walking-pet-care.svg";
import KnittingCrochetingIcon from "./hobbies/knitting-crocheting.svg";
import SkiingSnowboardingIcon from "./hobbies/skiing-snowboarding.svg";
import WildlifePhotographyIcon from "./hobbies/wildlife-photography.svg";
import InternationalTravelIcon from "./hobbies/international-travel.svg";
import WellnessAndSelfcareIcon from "./hobbies/wellness-and-selfcare.svg";
import TechnologyAndGamingIcon from "./hobbies/technology-and-gaming.svg";
import StreetFoodExploringIcon from "./hobbies/street-food-exploring.svg";
import HostingDinnerPartiesIcon from "./hobbies/hosting-dinner-parties.svg";
import VirtualRealityGamingIcon from "./hobbies/virtual-reality-gaming.svg";
import WatchingSportsEventsIcon from "./hobbies/watching-sports-events.svg";
import TravelAndExplorationIcon from "./hobbies/travel-and-exploration.svg";
import ExploringLocalCultureIcon from "./hobbies/exploring-local-culture.svg";
import ScubaDivingSnorkelingIcon from "./hobbies/scuba-diving-snorkeling.svg";
import TvSeriesBingeWatchingIcon from "./hobbies/tv-series-binge-watching.svg";
import AdventureAndAdrenalineIcon from "./hobbies/adventure-and-adrenaline.svg";
import MixologyCocktailMakingIcon from "./hobbies/mixology-cocktail-making.svg";
import VistingHistoricalSitesIcon from "./hobbies/visiting-historical-sites.svg";
import EntertainmentAndLeisureIcon from "./hobbies/entertainment-and-leisure.svg";
import PlayingMusicalInstrumentIcon from "./hobbies/playing-musical-instrument.svg";
import VistingMuseumsAndGalleriesIcon from "./hobbies/visiting-museums-and-galleries.svg";
import AnimalRescueAndVolunteeringIcon from "./hobbies/animal-rescue-and-volunteering.svg";
import SocialAndCommunityActivitiesIcon from "./hobbies/social-and-community-activities.svg";

const HobbiesIconMapping = {
  yoga: YogaIcon,
  golf: GolfIcon,
  sewing: SewingIcon,
  tennis: TennisIcon,
  hiking: HikingIcon,
  gaming: GamingIcon,
  baking: BakingIcon,
  cooking: CookingIcon,
  cycling: CyclingIcon,
  camping: CampingIcon,
  karaoke: KaraokeIcon,
  pilates: PilatesIcon,
  drawing: DrawingIcon,
  pottery: PotteryIcon,
  singing: SingingIcon,
  writing: WritingIcon,
  esports: EsportsIcon,
  sailing: SailingIcon,
  spa_days: SpaDaysIcon,
  robotics: RoboticsIcon,
  climbing: ClimbingIcon,
  swimming: SwimmingIcon,
  painting: PaintingIcon,
  designing: DesigningIcon,
  sculpture: SculptureIcon,
  badminton: BadmintonIcon,
  skydiving: SkydivingIcon,
  ziplining: ZipliningIcon,
  gardening: GardeningIcon,
  road_trips: RoadTripsIcon,
  meditation: MeditationIcon,
  journaling: JournalingIcon,
  basketball: BasketballIcon,
  stargazing: StargazingIcon,
  board_games: BoardGamesIcon,
  backpacking: BackpackingIcon,
  calligraphy: CalligraphyIcon,
  photography: PhotographyIcon,
  programming: ProgrammingIcon,
  paragliding: ParaglidingIcon,
  charity_work: CharityWorkIcon,
  speed_dating: SpeedDatingIcon,
  martial_arts: MartialArtsIcon,
  kite_surfing: KiteSurfingIcon,
  horse_riding: HorseRidingIcon,
  escape_rooms: EscapeRoomsIcon,
  wine_tasting: WineTastingIcon,
  aromatherapy: AromatherapyIcon,
  volunteering: VolunteeringIcon,
  scrapbooking: ScrapBookingIcon,
  food_blogging: FoodBloggingIcon,
  bird_watching: BirdWatchingIcon,
  food_and_drink: FoodAndDrinkIcon,
  culinary_tours: CulinaryToursIcon,
  coffee_culture: CoffeeCultureIcon,
  luxury_cruises: LuxuryCruisesIcon,
  bungee_jumping: BungeeJumpingIcon,
  diy_and_crafting: DiyCraftingIcon,
  acting_and_drama: ActingDramaIcon,
  jewelry_making: JewelleryMakingIcon,
  watching_movies: WatchingMoviesIcon,
  tv_series: TvSeriesBingeWatchingIcon,
  mixology: MixologyCocktailMakingIcon,
  arts_and_culture: ArtsAndCultureIcon,
  creative_hobbies: CreativeHobbiesIcon,
  networking_events: NetworkingEventsIcon,
  running_and_jogging: RunningJoggingIcon,
  podcast_listening: PodcastListeningIcon,
  soccer_and_football: SoccerFootballIcon,
  sports_and_fitness: SportsAndFitnessIcon,
  nature_and_animals: NatureAndAnimalsIcon,
  attending_concerts: AttendingConcertsIcon,
  tech_gadget_reviews: TechGadgetReviewsIcon,
  gym_and_weightlifting: GymWeightliftingIcon,
  trivia_and_quiz_nights: TriviaQuizNightsIcon,
  international_travel: InternationalTravelIcon,
  wildlife_photography: WildlifePhotographyIcon,
  street_food_exploring: StreetFoodExploringIcon,
  technology_and_gaming: TechnologyAndGamingIcon,
  knitting_and_crocheting: KnittingCrochetingIcon,
  dog_walking_and_pet_care: DogWalkingPetCareIcon,
  wellness_and_self_care: WellnessAndSelfcareIcon,
  skiing_and_snowboarding: SkiingSnowboardingIcon,
  virtual_reality_gaming: VirtualRealityGamingIcon,
  hosting_dinner_parties: HostingDinnerPartiesIcon,
  watching_sports_events: WatchingSportsEventsIcon,
  travel_and_exploration: TravelAndExplorationIcon,
  exploring_local_culture: ExploringLocalCultureIcon,
  visting_historical_sites: VistingHistoricalSitesIcon,
  adventure_and_adrenaline: AdventureAndAdrenalineIcon,
  suba_diving_and_snorkeling: ScubaDivingSnorkelingIcon,
  entertainment_and_leisure: EntertainmentAndLeisureIcon,
  playing_musical_instrument: PlayingMusicalInstrumentIcon,
  animal_rescue_volunteering: AnimalRescueAndVolunteeringIcon,
  visting_museums_and_galleries: VistingMuseumsAndGalleriesIcon,
  social_and_community_activities: SocialAndCommunityActivitiesIcon,
};

export default HobbiesIconMapping;
